import { Badge } from '@mantine/core';
import { useNotificationScope } from '../../useNotificationScope';

/**
 * Бейдж пункта меню со счётчиком непрочитанных уведомлений раздела.
 *
 * Область объявляет модуль (`registerNotificationScope`), платформа только
 * считает и рисует. Пусто — компонент ничего не рендерит, пункт меню выглядит
 * как обычно.
 *
 * @example
 * // client/bootstrap.ts
 * {
 *   label: 'Таблицы подрядчиков',
 *   url: '/grasias/contractor-docs',
 *   badge: () => <NotificationScopeBadge scope='grasias:contractor-docs' />,
 * }
 */
export function NotificationScopeBadge({
  scope,
  color = 'red',
}: {
  /** Код области из `registerNotificationScope` */
  scope: string;
  /** Цвет бейджа, если раздел хочет отличаться от общего красного */
  color?: string;
}) {
  const { count } = useNotificationScope(scope);

  if (!count) return null;

  return (
    <Badge size='xs' color={color} variant='filled'>
      {String(count)}
    </Badge>
  );
}

export default NotificationScopeBadge;
